import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
interface ErrorStateProps {
  message: string;
}
export const ErrorState = ({
  message
}: ErrorStateProps) => {
  return <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-80 z-[25]" data-id="element-255">
      <div className="text-center p-6 max-w-md" data-id="element-256">
        <AlertTriangleIcon className="h-12 w-12 text-red-500 mx-auto mb-4" data-id="element-257" />
        <p className="text-lg font-medium text-gray-800" data-id="element-258">{message}</p>
        <button className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" onClick={() => window.location.reload()} data-id="element-259">
          আবার চেষ্টা করুন
          <span className="text-xs block" data-id="element-260">(Try Again)</span>
        </button>
      </div>
    </div>;
};